<template>
    <div :id="modalID" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: 550px">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <div style="font-size: 15px; font-weight: 500; line-height: 21px; color: #00203f">{{ $t('views.inventory.modals.newFilter.title') }}</div>
                    <button type="button" class="close-button btn btn-link" @click="closeModal"><i class="bi bi-x-lg" style="color: #677788"></i></button>
                </div>
                <div class="modal-body">
                    <table class="table modal-table">
                        <thead class="thead-light">
                            <tr>
                                <th>{{ $t('views.inventory.modals.newFilter.filterName.title') }}</th>
                                <th style="max-width: 100px; text-align: center">{{ $t('views.inventory.modals.newFilter.actions.title') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="borde-right: none">
                                    <input v-model.trim="filterName" type="text" class="form-control" :placeholder="$t('views.inventory.modals.newFilter.filterName.placeholder')" />
                                </td>
                                <td style="max-width: 70px; text-align: center">
                                    <button class="btn btn-primary btn-sm" :disabled="isSubmitButtonDisabled" @click="save">
                                        {{ $t('views.inventory.modals.newFilter.save') }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Modal } from 'bootstrap'

export default {
    name: 'NewFilter',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalID: 'NewFilter-' + crypto.randomUUID(),
            modalInstance: null,
            filterName: '',
        }
    },
    computed: {
        isSubmitButtonDisabled() {
            return !this.filterName
        },
    },
    methods: {
        ...mapActions('inventory', ['createFilter', 'getFilters']),
        closeModal() {
            this.filterName = ''
            this.modalInstance.hide()
            this.$emit('update:modelValue', false)
        },
        save() {
            this.createFilter({ filter_name: this.filterName })
                .then(() => {
                    this.filterName = ''
                })
                .finally(() => {
                    this.closeModal()
                })
        },
    },
    watch: {
        modelValue: function (data) {
            if (data) {
                const modalEl = document.getElementById(this.modalID)
                this.modalInstance = new Modal(modalEl, { backdrop: true })
                this.modalInstance.show()
                modalEl.addEventListener('hidden.bs.modal', () => {
                    this.closeModal()
                })
            } else {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
[id^='NewFilter-'] {
    .close-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:hover {
            background-color: #f8fafd;
        }
    }
}
.modal-table {
    tbody {
        tr {
            td {
                &:first-child {
                    border-right: none;
                }
            }
        }
    }
}
</style>
